(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabSection = document.querySelector('[data-tabs]');
  if (!tabSection) return;

  const tabs = tabSection.querySelectorAll('.tabs button');
  const panels = tabSection.querySelectorAll('.tab-panel');

  function initSlickFor(panel) {
    const carousel = panel.querySelector('.grid-flex');
    if (carousel && !carousel.classList.contains('slick-initialized')) {
      const slidesPerRow = parseInt(carousel.dataset.slidesPerRow) || 4;
      $(carousel).slick({
        infinite: false,
        slidesToShow: slidesPerRow,
        slidesToScroll: slidesPerRow > 1 ? slidesPerRow - 1 : 1,
        swipeToSlide: true,
        dots: false,
        arrows: true,
        prevArrow: $(panel).find('.featured-collection-controls--prev button'),
        nextArrow: $(panel).find('.featured-collection-controls--next button'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }

  function destroySlickFor(panel) {
    const carousel = panel.querySelector('.grid-flex');
    if (carousel && $(carousel).hasClass('slick-initialized')) {
      $(carousel).slick('unslick');
    }
  }

  // Handle tab switching
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      // Reset tabs
      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => {
        p.classList.remove('active');
        destroySlickFor(p);
      });

      // Activate current
      tab.classList.add('active');
      panels[index].classList.add('active');
      initSlickFor(panels[index]);
    });
  });

  // Init first panel on load
  if (panels.length > 0) {
    initSlickFor(panels[0]);
  }
});


  } catch(e) { console.error(e); }
})();
})();
